import { type ReactNode, useRef } from 'react';
import { useToggle } from '@/hooks/useToggle';
import DefaultOptionsMenu from '@/components/DefaultOptionsMenu';
import { OptionsIcon } from '@/icons';
import TableCell, { type TableCellProps } from '../TableCell';
import { classes } from './utils';

export interface OptionsCellProps extends TableCellProps {
  extraOptions?: ReactNode;
  onEdit: () => void;
  onDelete: () => void;
}

export default function OptionsCell({
  onEdit,
  onDelete,
  extraOptions,
  ...props
}: OptionsCellProps) {
  const menuToggleRef = useRef(null);
  const [isMenuOpen, toggleMenu] = useToggle(false);

  const handleEdit = () => {
    onEdit();
    toggleMenu();
  };

  const handleDelete = () => {
    onDelete();
    toggleMenu();
  };

  return (
    <TableCell {...props}>
      <div className={classes.optionsWrapper}>
        <OptionsIcon
          ref={menuToggleRef}
          className={classes.optionsIcon}
          color="grey-6"
          onClick={() => toggleMenu()}
        />
        <DefaultOptionsMenu
          anchorTo={menuToggleRef.current}
          open={isMenuOpen}
          extraOptions={extraOptions}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onClose={() => toggleMenu()}
        />
      </div>
    </TableCell>
  );
}
